module.exports = __webpack_public_path__ + "static/media/slideshow-4.ac431a23.png";